import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  // middleware: 'members-auth',
  layout: 'password',
  head() {
    return {
      title: 'Logout Members Area - EXTRA'
    };
  },
  mounted() {
    window.extra_data_ul.log([{
      kingdom: 'view',
      phylum: 'page',
      class: 'members_area',
      subclass: 'logout'
    }]);
    this.$cookies.remove('members_token');
    this.$cookies.remove('extra_member_id');
    this.$cookies.remove('extra_member_tag');
    this.$cookies.remove('extra_aff_pii');
    window.sessionStorage.removeItem('EXTRA_MEMBER_TOKEN');
    this.$router.push('/');
  }
};